/**
 * php-api's responder rewrites every `null` in a response body to `''`, recursively
 * (`responder::remove_nulls()`, called from `prerender()`); hunkware-api answers `null` and that
 * divergence is accepted server-side (quote-create doc 05 D1). The created quote is persisted
 * (`booking-v4-quote`) and re-sent by later steps, so the Node branch restores php-api's spelling
 * before anything reads it — php-api warns on every NULL it is sent back.
 */
export const phpRemoveNulls = <T>(value: T): T => {
  if (value === null) {
    return "" as T;
  }

  if (Array.isArray(value)) {
    return value.map(phpRemoveNulls) as T;
  }

  if (typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>).map(([key, item]) => [
        key,
        phpRemoveNulls(item),
      ]),
    ) as T;
  }

  return value;
};
